import { styled, Tab, Theme } from '@mui/material'
import { TabProps } from '@mui/material/Tab/Tab'
import React from 'react'

import { WTPayload } from '@f-fertighaus/applications/Next/types/WTPayload'
import { webtrack } from '@f-fertighaus/applications/Next/utils/webtrack'

const getCustomStyles = ({ theme }: { theme: Theme }) => ({
  '&.MuiTab-root': {
    fontWeight: 700,
    textTransform: 'initial',
    fontSize: theme.typography.body1.fontSize,
    outlineOffset: '-2px'
  },
  '&.Mui-selected': {
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.common.white
  }
})

interface A11yProps {
  id: string
  'aria-controls': string
}

const getA11yProps = (index: number): A11yProps => ({
  id: `simple-tab-${index}`,
  'aria-controls': `simple-tabpanel-${index}`
})

interface TabLabelProps extends TabProps {
  label: string
  index: number
}

const StyledTabLabel = styled(({ index, label, ...rest }: TabLabelProps) => (
  <Tab label={label} {...getA11yProps(index)} {...rest} />
))(getCustomStyles)

interface TabLabelWithWTProps extends TabLabelProps {
  wtPayload: WTPayload
}

export const TabLabelWithWT = ({ wtPayload, ...rest }: TabLabelWithWTProps) => {
  const trackTabSelect = () => webtrack(wtPayload)

  return <StyledTabLabel onClick={trackTabSelect} {...rest} />
}
